import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import AccountComboboxInput from "../Reusable/AccountComboboxInput";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextField";

const LedgerGroupForm = (props: any) => {
  const { setOpenLedgerformPopup } = props;
  const {
    control,
    formState: { errors },
    handleSubmit,
    register,
    setValue,
    getValues,
    clearErrors,
    setError,
  } = useForm<any>({});

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["ledger-group"],
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.COA;
    const formData = {
      ...values,
      is_group: true,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenLedgerformPopup((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data) => handleCreate(data, setError))}
      autoComplete="off"
    >
      <div className={tw`grid gap-x-2`}>
        <TextField label="Name" name={"name"} control={control} />
        <AccountComboboxInput
          url={APIS.COA}
          queryKey={"cart-of-account"}
          register={register("parent")}
          errors={errors?.parent}
          name={"parent"}
          label={"Account Type"}
          setValue={setValue}
          props={{
            is_active: true,
            level: 1,
            is_group: true,
          }}
          getValues={getValues}
          placeholder={"Search... "}
          clearErrors={clearErrors}
        />
      </div>
      <div className={tw`mt-4 w-full `}>
        <div className={tw`w-32 ml-auto`}>
          <Button label="Save" isLoading={isPostLoading} />
        </div>
      </div>
    </form>
  );
};

export default LedgerGroupForm;
